function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F2F2F2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#EBECEE",
  stopOpacity: 0.11
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "#CAD3DB",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: "85%",
  stopColor: "#B5C2D0",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#ADBCCB"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 120.5,
  r: 120.5,
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(48 34)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 170.531,
  height: 229.913,
  x: 2.31,
  y: 2.284,
  fill: "#FFF",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M168.273 4.568a2.284 2.284 0 0 1 2.284 2.284v220.777a2.284 2.284 0 0 1-2.284 2.284H6.878a2.284 2.284 0 0 1-2.284-2.284V6.852a2.284 2.284 0 0 1 2.284-2.284h161.395m0-4.568H6.878A6.852 6.852 0 0 0 .026 6.852v220.777a6.852 6.852 0 0 0 6.852 6.851h161.395a6.852 6.852 0 0 0 6.852-6.851V6.852A6.852 6.852 0 0 0 168.273 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 140.84,
  height: 78.414,
  x: 16.775,
  y: 57.859,
  fill: "#15406B",
  opacity: 0.29,
  rx: 8.94
}), /*#__PURE__*/React.createElement("g", {
  fill: "#15406B",
  opacity: 0.29,
  transform: "translate(16.775 146.17)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 140.84,
  height: 13.62,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 91.356,
  height: 5.481,
  y: 22.839,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 76.13,
  height: 5.481,
  y: 32.584,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 98.969,
  height: 5.481,
  y: 42.633,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 63.34,
  height: 5.481,
  y: 52.377,
  rx: 2.741
})), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M3.071 218.493H172.08v12.942H3.071zM173.602 14.465H.026v6.09C.026 3.806-1.436.761 17.536.761h140.018c16.048 0 16.048 3.045 16.048 19.794v-6.09z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  opacity: 0.5,
  transform: "translate(71.588 81.46)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.747,
  cy: 5.245,
  r: 4.865
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.367 28.785L26.387 6.09a1.69 1.69 0 0 0-1.416-.822c-.57.013-1.091.326-1.37.822l-8.588 15.706-4.971-6.205a1.599 1.599 0 0 0-1.44-.616c-.549.062-1.03.397-1.278.89L.83 28.845a1.622 1.622 0 0 0 1.454 2.368H37.98a1.622 1.622 0 0 0 1.409-.807 1.644 1.644 0 0 0-.023-1.621z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M106.197 43.272h3.258v-.578h-1.225v-4.888h2.436l3.129 5.466h1.522v-.578h-.875l-2.924-5.048a2.802 2.802 0 0 0 2.52-3.045v-.457c0-1.949-1.08-2.976-3.639-2.976h-4.225v.57h1.127v10.948h-1.127v.586h.023zm2.033-6.09v-5.436h2.047c2.01 0 2.87.67 2.87 2.398v.526c0 1.75-1.012 2.52-2.786 2.52h-2.131v-.008zm9.896 6.182a3.563 3.563 0 0 0 2.695-1.21h.039a1.073 1.073 0 0 0 1.24 1.149 2.17 2.17 0 0 0 .663-.1v-.525h-.366c-.525 0-.76-.197-.76-.928v-5.68c0-1.766-1.09-2.36-2.719-2.36a6.777 6.777 0 0 0-2.801.594v.594a7.324 7.324 0 0 1 2.641-.495c1.317 0 2.033.388 2.033 1.79v1.575l-2.626.32c-1.523.19-2.68.837-2.68 2.375v.563c0 1.477.89 2.353 2.664 2.353m.153-.602c-1.31 0-1.995-.662-1.995-1.781v-.579c0-1.21.86-1.697 2.116-1.82l2.368-.227v3.288a3.494 3.494 0 0 1-2.49 1.12m4.142 3.205h3.045v-.556h-1.195v-2.65c.785.403 1.66.597 2.543.564 2.154 0 3.806-1.28 3.806-4.568v-.761c0-3.449-1.484-4.31-3.464-4.31a4.187 4.187 0 0 0-2.877 1.15v-1.005h-1.827v.594h1.02V45.42h-1.02v.564h-.03zm4.286-3.259a4.682 4.682 0 0 1-2.428-.556v-6.691a3.913 3.913 0 0 1 2.626-1.066c1.698 0 2.832.647 2.832 3.57v.845c0 2.893-1.385 3.868-3.045 3.868m4.355 3.258h3.045v-.556h-1.195v-2.619c.785.403 1.66.597 2.542.564 2.155 0 3.807-1.28 3.807-4.568v-.761c0-3.449-1.485-4.31-3.464-4.31a4.157 4.157 0 0 0-2.87 1.15h-.038v-1.005h-1.82v.594h1.013V45.42h-1.013v.564l-.007-.03zm4.293-3.258a4.69 4.69 0 0 1-2.436-.556v-6.661a3.928 3.928 0 0 1 2.611-1.066c1.698 0 2.832.647 2.832 3.57v.845c0 2.893-1.377 3.868-3.045 3.868m8.375.67c2.207 0 3.806-1.28 3.806-4.568v-.632c0-3.25-1.652-4.515-3.806-4.515-2.155 0-3.807 1.295-3.807 4.515v.662c0 3.259 1.622 4.568 3.807 4.568m0-.647c-1.683 0-2.977-.967-2.977-3.807v-.799c0-2.801 1.294-3.806 2.977-3.806 1.682 0 2.976.982 2.976 3.806v.838c0 2.801-1.256 3.806-2.976 3.806m3.996.525h3.046v-.578h-1.158v-6.624a4.073 4.073 0 0 1 3.099-1.522v-.761a3.708 3.708 0 0 0-3.045 1.629h-.038v-1.607h-1.88v.594h1.035v8.253h-1.036v.578l-.023.038zm8.276.107c.452.002.903-.07 1.332-.213v-.571c-.35.076-.707.114-1.066.114-.845 0-1.157-.38-1.157-1.188v-7.11h2.223v-.602h-2.2v-2.01h-.845v2.01h-1.173v.594h1.173v7.233c0 1.18.563 1.705 1.736 1.705"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003961",
  d: "M26.17 43.272h3.76v-2.284h-.594l-2.55-4.567 2.573-3.046h.556v-2.284h-4.713v2.284h.708l-2.573 2.962V33.39H24v-2.284H18.67v2.284h.647v7.613h-.647v2.284H24v-2.284h-.663v-1.812l.434-.404 2.398 4.484zm8.442.206c2.786 0 4.682-1.645 4.682-4.812v-.601c0-3.167-1.911-4.811-4.682-4.811-2.771 0-4.636 1.644-4.636 4.811v.617c0 3.167 1.872 4.811 4.636 4.811m0-2.482c-.662 0-.944-.426-.944-1.736v-1.682c0-1.294.282-1.728.944-1.728.662 0 .952.434.952 1.728v1.667c0 1.31-.282 1.736-.952 1.736m4.811 2.284h4.568v-2.284h-.335V36.23a1.72 1.72 0 0 1 .807-.243c.419 0 .61.16.61.76v4.272h-.351v2.284h4.294v-2.284h-.267V36.23a1.69 1.69 0 0 1 .807-.243c.419 0 .617.16.617.76v4.272h-.335v2.284h4.568v-2.284h-.594v-5.542c0-1.576-1.035-2.239-2.368-2.239a3.304 3.304 0 0 0-2.763 1.256h-.092a2.154 2.154 0 0 0-2.17-1.256 3.197 3.197 0 0 0-2.717 1.241h-.069v-1.035H39.5v2.398h.632v5.17H39.5v2.283l-.076-.015zm15.143 0h4.567v-2.284h-.335V36.23c.245-.147.522-.231.807-.243.42 0 .61.16.61.76v4.272h-.35v2.284h4.293v-2.284h-.335V36.23a1.69 1.69 0 0 1 .807-.243c.419 0 .609.16.609.76v4.272h-.327v2.284h4.53v-2.284h-.594v-5.542c0-1.576-1.028-2.239-2.36-2.239a3.327 3.327 0 0 0-2.772 1.256h-.083a2.154 2.154 0 0 0-2.17-1.256 3.197 3.197 0 0 0-2.718 1.241h-.068v-1.035h-4.134v2.398h.632v5.17h-.632l.023 2.268zm18.141.205a3.274 3.274 0 0 0 2.596-1.05h.092v.845h4.118v-2.284h-.616v-7.552h-4.218v2.398h.594v4.613a1.37 1.37 0 0 1-.86.275c-.488 0-.663-.229-.663-.823v-6.463h-4.217v2.398h.594v5.01c0 1.629.631 2.626 2.588 2.626m7.065-.206h4.568v-2.284h-.366v-4.743a1.79 1.79 0 0 1 .906-.258c.442 0 .632.152.632.76v4.272h-.365v2.284h4.567v-2.284h-.593v-5.542c0-1.576-1.066-2.239-2.399-2.239a3.342 3.342 0 0 0-2.786 1.241h-.084v-1.035h-4.118v2.398h.632v5.17h-.632v2.283l.038-.023zm12.782.175c1.172 0 2.155-.403 2.558-1.301h.069c.175.76.715 1.248 2.154 1.248a4.857 4.857 0 0 0 1.675-.213v-2.17h-.259c-.266 0-.35-.106-.35-.388V36.23c0-2.154-1.28-3-3.73-3a12.046 12.046 0 0 0-3.96.655v2.376c.756-.119 1.52-.177 2.285-.175 1.385 0 1.804.213 1.804.76v.473l-1.858.282c-1.614.243-2.976.852-2.976 2.68v.487c0 1.926.997 2.649 2.61 2.649m1.592-2.048a.678.678 0 0 1-.716-.723v-.685a.837.837 0 0 1 .876-.944l.472-.054v2.147a.8.8 0 0 1-.632.282m5.025 1.873h4.872V40.98h-.632V30.452h-4.24v2.284h.631v8.298h-.631v2.23z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M167.52 262.197l-.293-150.95c0-8.713 7.063-15.775 15.774-15.775h34.947c6.669 0 3.964 6.92 3.964 13.559v153.166H167.52z",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(159.045 103.374)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 87.549,
  height: 178.144,
  y: 0.761,
  fill: "#FFF",
  rx: 14
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M62.046 8.374H25.504c-4.203 0-6.09-3.745-6.09-8.374h48.722c0 4.629-1.888 8.374-6.09 8.374z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M185.067 144.264h2.284v-.404h-.853v-3.448h1.713l2.208 3.852h1.088v-.404h-.616l-2.056-3.555a1.987 1.987 0 0 0 1.774-2.177v-.32c0-1.37-.761-2.094-2.566-2.094h-2.976v.396h.761v7.735h-.761v.419zm1.43-4.279v-3.875h1.44c1.423 0 2.025.472 2.025 1.698v.365c0 1.234-.716 1.774-1.957 1.774h-1.522l.015.038zm6.974 4.355a2.528 2.528 0 0 0 1.904-.853.761.761 0 0 0 .875.815c.16-.001.32-.027.472-.076v-.366h-.259c-.373 0-.555-.137-.555-.654v-4.013c0-1.248-.762-1.667-1.919-1.667-.68 0-1.35.143-1.972.419v.45a5.283 5.283 0 0 1 1.858-.382c.921 0 1.431.275 1.431 1.264v1.112l-1.857.22c-1.059.138-1.888.594-1.888 1.675v.396c0 1.043.631 1.66 1.88 1.66m.114-.419c-.929 0-1.408-.472-1.408-1.264v-.403c0-.853.601-1.195 1.522-1.287l1.668-.16v2.322a2.482 2.482 0 0 1-1.751.762m2.908 2.284h2.139v-.396h-.837v-1.858a3.662 3.662 0 0 0 1.789.396c1.522 0 2.687-.906 2.687-3.236v-.517c0-2.436-1.05-3.045-2.444-3.045a2.946 2.946 0 0 0-2.025.814v-.7h-1.31v.419h.716v7.727h-.715v.396zm3.045-2.284a3.35 3.35 0 0 1-1.72-.396v-4.72a2.756 2.756 0 0 1 1.857-.762c1.195 0 1.995.457 1.995 2.52v.617c0 2.033-.975 2.725-2.132 2.725m3.045 2.284h2.132v-.396h-.838v-1.857a3.662 3.662 0 0 0 1.79.396c1.522 0 2.687-.906 2.687-3.236v-.517c0-2.437-1.043-3.046-2.444-3.046a2.961 2.961 0 0 0-2.025.815v-.685h-1.302v.419h.761v7.727h-.76v.396-.016zm3.045-2.284a3.35 3.35 0 0 1-1.72-.395v-4.705a2.756 2.756 0 0 1 1.857-.762c1.196 0 1.995.457 1.995 2.52v.617c0 2.033-.974 2.725-2.132 2.725m5.9.472c1.523 0 2.703-.905 2.703-3.197v-.472c0-2.284-1.165-3.182-2.703-3.182-1.537 0-2.695.913-2.695 3.182v.45c0 2.283 1.15 3.197 2.695 3.197m0-.465c-1.187 0-2.1-.677-2.1-2.65v-.532c0-1.972.913-2.665 2.1-2.665 1.188 0 2.094.693 2.094 2.665v.594c0 1.972-.883 2.65-2.094 2.65m2.817.372h2.124v-.403h-.814v-4.667a2.847 2.847 0 0 1 2.185-1.074v-.532a2.604 2.604 0 0 0-2.17 1.15v-1.135h-1.31v.419h.762v5.816h-.716v.403l-.06.023zm5.832.076c.318.005.635-.047.936-.152v-.38c-.25.058-.505.086-.761.083-.586 0-.815-.266-.815-.837v-5.01h1.569v-.441h-1.576v-1.416h-.594v1.416h-.822v.419h.822v5.093c0 .83.396 1.202 1.226 1.202"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003961",
  d: "M178.291 129.327h2.642v-1.591h-.419l-1.804-3.213 1.827-2.116h.396v-1.591h-3.327v1.59h.472l-1.812 2.087v-2.086h.464v-1.591h-3.745v1.59h.457v5.33h-.457v1.591h3.745v-1.591h-.464v-1.287l.305-.281 1.72 3.159zm5.953.145c1.957 0 3.29-1.158 3.29-3.388v-.434c0-2.238-1.34-3.395-3.29-3.395-1.948 0-3.273 1.164-3.273 3.395v.434c0 2.23 1.317 3.388 3.273 3.388m0-1.751c-.472 0-.662-.297-.662-1.218v-1.173c0-.913.19-1.226.662-1.226.472 0 .67.313.67 1.226v1.173c0 .92-.198 1.218-.67 1.218m3.388 1.606h3.236v-1.591h-.236v-3.373c.173-.103.37-.16.57-.167.298 0 .427.106.427.525v3.045h-.244v1.591h3.046v-1.621h-.252v-3.373a1.18 1.18 0 0 1 .571-.167c.297 0 .434.106.434.525v3.045h-.236v1.591h3.198v-1.621h-.419v-3.898a1.523 1.523 0 0 0-1.667-1.583 2.322 2.322 0 0 0-1.95.913h-.06a1.523 1.523 0 0 0-1.523-.89 2.284 2.284 0 0 0-1.926.89h-.045v-.761h-2.916v1.69h.449v3.639h-.45v1.591h-.007zm10.658 0h3.236v-1.591h-.236v-3.373c.173-.103.37-.16.571-.167.297 0 .426.106.426.525v3.045h-.243v1.591h3.045v-1.621h-.236v-3.373a1.18 1.18 0 0 1 .57-.167c.298 0 .435.106.435.525v3.045h-.236v1.591h3.197v-1.621h-.418v-3.898a1.523 1.523 0 0 0-1.668-1.583 2.337 2.337 0 0 0-1.956.913h-.061a1.523 1.523 0 0 0-1.523-.89 2.284 2.284 0 0 0-1.918.89h-.046v-.761h-2.916v1.69h.442v3.639h-.442l-.023 1.591zm12.79.145a2.284 2.284 0 0 0 1.827-.762h.061v.594h2.9v-1.568h-.433v-5.33h-2.954v1.69h.426v3.244a.967.967 0 0 1-.601.198c-.35 0-.472-.16-.472-.579v-4.567h-2.97v1.69h.42v3.524c0 1.15.441 1.85 1.827 1.85m4.971-.144h3.25v-1.576h-.258v-3.357c.193-.117.414-.18.64-.183.312 0 .449.106.449.525v3.045h-.267v1.591h3.228v-1.621h-.419v-3.898a1.523 1.523 0 0 0-1.69-1.583 2.352 2.352 0 0 0-1.964.875h-.053v-.723h-2.9v1.69h.44v3.639h-.44v1.591l-.016-.015zm9.014.122a1.82 1.82 0 0 0 1.796-.914h.054c.122.54.502.876 1.522.876.401.021.803-.025 1.188-.138v-1.522h-.183c-.19 0-.25-.076-.25-.274v-3.099c0-1.522-.9-2.108-2.627-2.108a8.664 8.664 0 0 0-2.794.456v1.675a10.445 10.445 0 0 1 1.598-.122c.975 0 1.272.153 1.272.556v.335l-1.31.198c-1.134.175-2.1.601-2.1 1.888v.343a1.63 1.63 0 0 0 1.841 1.865m1.12-1.439a.48.48 0 0 1-.503-.51v-.48a.594.594 0 0 1 .617-.67l.335-.038v1.523a.579.579 0 0 1-.45.198m3.548 1.317h3.426v-1.614h-.441v-7.446h-2.985v1.6h.442v5.846h-.442v1.614z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M160.378 152.943h84.504v52.446h-84.504z",
  opacity: 0.29
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  opacity: 0.5,
  transform: "translate(191.591 170.369)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.857,
  cy: 3.129,
  r: 2.84
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.717 16.855L15.15 3.61a.997.997 0 0 0-.83-.48.952.952 0 0 0-.815.495l-5.009 9.135-2.893-3.623a.944.944 0 0 0-1.591.16L.206 16.862a.944.944 0 0 0 .41 1.271.96.96 0 0 0 .435.107h20.821a.952.952 0 0 0 .822-1.416l.023.03z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#15406B",
  opacity: 0.29,
  transform: "translate(168.448 213.24)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 70.344,
  height: 12.181,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 69.583,
  height: 3.837,
  y: 18.961,
  rx: 1.918
}), /*#__PURE__*/React.createElement("rect", {
  width: 53.291,
  height: 3.837,
  y: 26.376,
  rx: 1.918
}), /*#__PURE__*/React.createElement("rect", {
  width: 68.517,
  height: 3.837,
  y: 33.791,
  rx: 1.918
}), /*#__PURE__*/React.createElement("rect", {
  width: 53.291,
  height: 3.837,
  y: 41.206,
  rx: 1.918
}), /*#__PURE__*/React.createElement("rect", {
  width: 63.949,
  height: 3.837,
  y: 48.622,
  rx: 1.918
})), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M235.937 105.658a9.136 9.136 0 0 1 9.135 9.136v156.828a9.136 9.136 0 0 1-9.135 9.135h-66.233a9.136 9.136 0 0 1-9.136-9.135V114.794a9.136 9.136 0 0 1 9.136-9.136h66.233m0-3.045h-66.233c-6.728 0-12.181 5.454-12.181 12.18v156.829c0 6.727 5.453 12.18 12.18 12.18h66.234c6.727 0 12.18-5.453 12.18-12.18V114.794c0-6.727-5.453-12.181-12.18-12.181z"
}));

var SvgKrDigital = function SvgKrDigital(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 284,
    viewBox: "0 0 249 284",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKrDigital, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kr_digital.27f216e2.svg";
export { ForwardRef as ReactComponent };